import * as React from "react";
const SvgPen20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m12.124 3.31-9.88-2.28a.998.998 0 0 0-.037-.008L.666.666l.356 1.541.008.037 2.28 9.88A5 5 0 0 0 8.182 16h.404l3.914 3.914 7.414-7.414L16 8.586v-.404a5 5 0 0 0-3.876-4.872ZM7.068 8.482l-3.31-3.31 1.501 6.503A3 3 0 0 0 8.182 14h2.404L14 10.586V8.182a3 3 0 0 0-2.325-2.923l-6.502-1.5 3.31 3.309A2.003 2.003 0 0 1 11 9a2 2 0 1 1-3.932-.518Zm8.631 3.233.016-.016.285-.285 1.086 1.086-4.586 4.586L11.414 16l.285-.285.016-.016 3.984-3.984Z",
      clipRule: "evenodd"
    })
  );
export default SvgPen20Px;
